class NewPasswordUsersController {
  static controller($scope, $state, $stateParams, PasswordResetService, $translate) {
    'ngInject';

    $translate.use($state.params.lang);
    $scope.newPasswordSubmit = function(newpasswordForm) {
      if(newpasswordForm.password.$valid && newpasswordForm.password2.$valid) {

        var promise = PasswordResetService.resetClientPassword($state.params.email, $state.params.token, newpasswordForm.password.$modelValue)

        promise.then(function(){
          $state.go('public.users.password-changed', {email: $state.params.email});
        }, function(error) { 
          console.log('error when chagning password')
          $scope.error = true;
        });
        
      }
    }
  };
}

export default NewPasswordUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/new-password.users.controller.js